import { Box } from '@mui/material';

export default function HomeSectionDivider({
  spaceBefore = false,
  spacing = { xs: 4, md: 6 },
}: {
  spaceBefore?: boolean;
  spacing?: { xs: number; md: number };
}) {
  return (
    <Box
      aria-hidden="true"
      sx={{
        width: { xs: '76%', sm: '68%', md: '100%' },
        maxWidth: 680,
        height: '1px',
        mx: 'auto',
        mt: spaceBefore ? spacing : 0,
        mb: spacing,
        background: 'linear-gradient(90deg, transparent, rgba(216, 163, 99, 0.4), transparent)',
      }}
    />
  );
}
